import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'

import { Title } from '~/shared/atoms/Collapse/CollapseStyle'
import Icon from '~/shared/atoms/Icon'

export const Section = styled.section`
  // sticky ScrollableTabs height
  scroll-margin-top: 114px;

  ${mediaQueryUp('m')} {
    scroll-margin-top: 137px;
  }
`

export const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};
`

export const ProductPageSectionSeparator = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray[200]};
`

export const TitleIcon = styled(Icon)`
  height: 1.5rem;
  width: 1.5rem;
  filter: ${({ theme }) => theme.filters.gray[700]};
  margin-right: 0.5rem;
`

export const TitleText = styled(Title)`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.black[900]};
  margin-right: 0.5rem;
`

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 0 1.25rem 0;

  ${mediaQueryUp('l')} {
    padding-left: 0;
    padding-right: 5rem;
  }
`
